import { AssetTransferMethodEnum, TransferStatusEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import { IsOptional, Matches, MaxLength } from "class-validator";

export class AssetTransfersDto {
    @ApiProperty()
    assetTransferId: number;

    @ApiProperty()
    assetLocationId : number;

    @ApiProperty()
    employeeId: number;

    @ApiProperty()
    assetsId: number;

    @ApiProperty()
    indentId: number;
    
    @ApiProperty()
    assetCategoryId: number;

    @ApiProperty()
    transferedBy:number;

    @ApiProperty()
    receivedBy:number;
    
    @ApiProperty()
    unitId: number;

    @ApiProperty()
    transferredDate: Date;

    @ApiProperty()
    receivedDate: Date;

    @ApiProperty()
    transferType: string;

    @ApiProperty()
    dcNumber: string;

    @ApiProperty()
    mrnNumber: string;

    @ApiProperty()
    fromPlant: number;

    @ApiProperty()
    toPlant: number;

    @ApiProperty()
    transferedQuantity: number;

    @ApiProperty()
    receivedQuantity: number;

    @ApiProperty()
    note: string;

    @ApiProperty()
    status : TransferStatusEnum;

    @ApiProperty()
    isActive: boolean;

    @ApiProperty()
    createdAt : Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, {message: 'Updated User allows maximum 40 characters'})
    @Matches(new RegExp('"^(?:[a-zA-Z\\s]|)+$"'), {message: 'Updated User should be only alphabets'})
    createdUser: string;

    @ApiProperty()
    updatedAt : Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, {message: 'Updated User allows maximum 40 characters'})
    @Matches(new RegExp('"^(?:[a-zA-Z\\s]|)+$"'), {message: 'Updated User should be only alphabets'})
    updatedUser: string;

    @ApiProperty()
    versionFlag: number;

}